// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes audio-wave {
  0% {
    height: 10px;
    trnsform: translateY(0px);
    background: #1f4fcc;
  }
  25% {
    height: 40px;
    trnsform: translateY(-5px);
    scaley: 1.7;
    background: #6785d3;
  }
  50% {
    height: 10px;
    trnsform: translateY(0px);
    scaley: 1.7;
    background: #c2d3ff;
  }
  100% {
    height: 10px;
    trnsform: translateY(0px);
    scaley: 1.7;
    background: fixed #eef3ff;
  }
}

.sound-wave {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 60px;
}
.sound-wave span {
  height: 18px;
  width: 10px;
  display: block;
  border-radius: 8px;
  background: #bec5d9;
  animation: audio-wave 2.2s infinite ease-in-out;
}
.stop-animation span {
  animation-play-state: paused;
}
.sound-wave span:nth-child(2) {
  left: 11px;
  background: #ffffff;
  animation-delay: 0.2s;
}
.sound-wave span:nth-child(3) {
  left: 22px;
  animation-delay: 0.4s;
}
.sound-wave span:nth-child(4) {
  left: 33px;
  animation-delay: 0.6s;
}
.sound-wave span:nth-child(5) {
  left: 44px;
  animation-delay: 0.8s;
}
.sound-wave span:nth-child(6) {
  left: 55px;
  animation-delay: 1s;
}

.audio-player {
  display: flex;
}

.hidden {
  display: none;
}

.options-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 40px;
  bottom: 0;
  width: 100%;
}

.call-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between;
  flex-grow: 1; */
}

.call-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between;
  flex-grow: 1; */
  /* width: 100%;
  height: 30vh; */
  width: 40vw;
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CallView/style.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;iBACe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;iBACe;EACf;iBACe;EACf,WAAW;EACX,aAAa;AACf","sourcesContent":["@keyframes audio-wave {\n  0% {\n    height: 10px;\n    trnsform: translateY(0px);\n    background: #1f4fcc;\n  }\n  25% {\n    height: 40px;\n    trnsform: translateY(-5px);\n    scaley: 1.7;\n    background: #6785d3;\n  }\n  50% {\n    height: 10px;\n    trnsform: translateY(0px);\n    scaley: 1.7;\n    background: #c2d3ff;\n  }\n  100% {\n    height: 10px;\n    trnsform: translateY(0px);\n    scaley: 1.7;\n    background: fixed #eef3ff;\n  }\n}\n\n.sound-wave {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  height: 60px;\n}\n.sound-wave span {\n  height: 18px;\n  width: 10px;\n  display: block;\n  border-radius: 8px;\n  background: #bec5d9;\n  animation: audio-wave 2.2s infinite ease-in-out;\n}\n.stop-animation span {\n  animation-play-state: paused;\n}\n.sound-wave span:nth-child(2) {\n  left: 11px;\n  background: #ffffff;\n  animation-delay: 0.2s;\n}\n.sound-wave span:nth-child(3) {\n  left: 22px;\n  animation-delay: 0.4s;\n}\n.sound-wave span:nth-child(4) {\n  left: 33px;\n  animation-delay: 0.6s;\n}\n.sound-wave span:nth-child(5) {\n  left: 44px;\n  animation-delay: 0.8s;\n}\n.sound-wave span:nth-child(6) {\n  left: 55px;\n  animation-delay: 1s;\n}\n\n.audio-player {\n  display: flex;\n}\n\n.hidden {\n  display: none;\n}\n\n.options-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 40px;\n  bottom: 0;\n  width: 100%;\n}\n\n.call-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* justify-content: space-between;\n  flex-grow: 1; */\n}\n\n.call-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* justify-content: space-between;\n  flex-grow: 1; */\n  /* width: 100%;\n  height: 30vh; */\n  width: 40vw;\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
